module.exports = __webpack_public_path__ + "static/media/anchor.abb98c08.jpg";